import { dateStrFormatRegex } from './regex';

// Arguments are inclusive. For example if minAge=18 and maxAge=110,
// the youngest valid age is "turned 18 today"
// the oldest valid age is "turning 111 tomorrow"
const ageInRange = (minAge, maxAge) => birthdateStr => {
	if (!birthdateStr) {
		return undefined;
	}
	if (!birthdateStr.match(dateStrFormatRegex)) {
		return 'Invalid date format. Please use MM/DD/YYYY';
	}
	const birthdateArr = birthdateStr.split('-');
	// Subtract 1 from month because months in Date objects are 0-based
	const birthdate = new Date(birthdateArr[0], birthdateArr[1] - 1, birthdateArr[2]);
	// Without setFullYear, the Date constructor assumes any 2-digit years are in the 1900s.
	birthdate.setFullYear(birthdateArr[0]);
	const today = new Date(Date.now());
	if (maxAge) {
		const tooOldDate = new Date(
			today.getFullYear() - maxAge - 1,
			today.getMonth(),
			today.getDate() + 1, // If this brings it past the end of the month, it will automatically adjust to be a valid date.
			// Ex: Dec 32 2000 automatically becomes Jan 1 2001
			// Also: Jan 0 2001 automatically becomes Dec 31 2000
		);
		if (birthdate < tooOldDate) {
			return `Must be at most ${maxAge} years old.`;
		}
	}
	if (minAge) {
		const tooYoungDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
		if (birthdate > tooYoungDate) {
			return `Must be at least ${minAge} years old.`;
		}
	}
	return undefined;
};

export default ageInRange;
